import {
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'

export function SortModal({
  sortModalOpen,
  closeSortModal,
  draftSort,
  sortableOptions,
  addDraftCriterion,
  updateDraftKey,
  updateDraftOrder,
  removeDraft,
  moveDraft,
  applyDraftSort
}) {
  return (
    <Dialog open={sortModalOpen} onClose={closeSortModal} fullWidth maxWidth='sm'>
      <DialogTitle>Ordenar resultados</DialogTitle>
      <DialogContent>
        <div className='flex flex-col gap-3 mt-2'>
          {draftSort.length === 0 && (
            <div className='text-sm text-gray dark:text-gray-400'>No hay criterios seleccionados.</div>
          )}
          {draftSort.map((item, idx) => (
            <div key={`${item.key}-${idx}`} className='grid grid-cols-12 gap-2 items-center'>
              <div className='col-span-7'>
                <Select
                  size='small'
                  fullWidth
                  value={item.key}
                  onChange={e => updateDraftKey(idx, e.target.value)}
                >
                  {sortableOptions.map(opt => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className='col-span-3'>
                <Select
                  size='small'
                  fullWidth
                  value={item.order}
                  onChange={e => updateDraftOrder(idx, e.target.value)}
                >
                  <MenuItem value='desc'>Descendente</MenuItem>
                  <MenuItem value='asc'>Ascendente</MenuItem>
                </Select>
              </div>
              <div className='col-span-2 flex items-center justify-end gap-1'>
                <button
                  className='px-2 py-1 rounded bg-light_gray dark:bg-dk-raised disabled:opacity-50'
                  onClick={() => moveDraft(idx, -1)}
                  disabled={idx === 0}
                  title='Subir prioridad'
                >
                  ↑
                </button>
                <button
                  className='px-2 py-1 rounded bg-light_gray dark:bg-dk-raised disabled:opacity-50'
                  onClick={() => moveDraft(idx, 1)}
                  disabled={idx === draftSort.length - 1}
                  title='Bajar prioridad'
                >
                  ↓
                </button>
                <button
                  className='px-2 py-1 rounded bg-light_gray dark:bg-dk-raised'
                  onClick={() => removeDraft(idx)}
                  title='Quitar'
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
          <div>
            <button
              className='px-3 py-2 rounded-lg bg-light_gray dark:bg-dk-raised disabled:opacity-50'
              onClick={addDraftCriterion}
              disabled={sortableOptions.length === draftSort.length}
            >
              Agregar criterio
            </button>
          </div>
          <div className='text-xs text-gray dark:text-gray-400'>
            Se aplica en orden: primero el primer criterio, luego el segundo si hay empate, etc.
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <button
          className='px-3 py-2 rounded-lg bg-light_gray dark:bg-dk-raised text-black dark:text-gray-100'
          onClick={closeSortModal}
        >
          Cancelar
        </button>
        <button
          className='px-3 py-2 rounded-lg bg-primary text-white hover:opacity-90'
          onClick={applyDraftSort}
        >
          Aplicar
        </button>
      </DialogActions>
    </Dialog>
  )
}
